import { render, staticRenderFns } from "./ConcernMailPage.vue?vue&type=template&id=3981e8b6"
import script from "./ConcernMailPage.vue?vue&type=script&lang=js"
export * from "./ConcernMailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports